import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import frameDefault from "../img/thumb/frame-100x60.png";
import defaultImage from "../img/default.jpg";
import Pagination from "react-js-pagination";
import MemberSidebar from "../inc/MemberSidebar";
import {jwtDecode} from "jwt-decode";

export default function Scholarship(prop) {
    let navigate = useNavigate();
    let {slug} = useParams();

    let [listing, setListing] = React.useState(null);
    let [category, setCategory] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);

    React.useEffect(() => {
        let memberTokens = localStorage.getItem(Utils.LOCAL_STORAGE_KEY);
        if(memberTokens) {
            let memberJson = jwtDecode(JSON.parse(memberTokens).accessToken);
            let checkExpireHrs = (Math.abs(new Date().getTime() - new Date(memberJson.latestLoginAt).getTime()) / 3600000);
            if(checkExpireHrs > Utils.HOURS_EXPIRE_LOGIN) {
                navigate((prop.lang === 'en' ? '/en':'/') + 'login');
            }
        }
        else {
            window.location.href = (prop.lang === 'en' ? '/en':'/') + 'login';
        }

        let title = 'ทุนวิจัย Scholarship | NCSA';
        document.title = title;
        const elDesc = document.querySelector("meta[name='description']");
        elDesc.setAttribute('content', title);
        const elOgTitle = document.querySelector("meta[property='og:title']");
        elOgTitle.setAttribute('content', title);
        const elOgDesc = document.querySelector("meta[property='og:description']");
        elOgDesc.setAttribute('content', title);
        const elOgImage = document.querySelector("meta[property='og:image']");
        elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
        const elOgUrl = document.querySelector("meta[property='og:url']");
        elOgUrl.setAttribute('content', window.location.href);

        (async function() {
            try {
                const resListing = await getListing();
                setListing(resListing);
                const resCategory = await getCategory();
                setCategory(resCategory);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        let categoryId = null;
        if(slug !== null && category !== null) {
            let currentCat = category.rows.filter(e => e.slug === slug);
            if (currentCat !== null) {
                categoryId = currentCat[0].id;
            }
        }

        const response = await fetch(Config.apiUrl +'/scholarship/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                categoryId: categoryId,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCategory() {
        const response = await fetch(Config.apiUrl +'/scholarshipCategory/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="scholarship" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 textrow">
                                    <span data-aos="fade-up">{prop.lang === 'en' ? 'Open Research':'ทุนวิจัยที่เปิดรับ'}</span>
                                </h2>
                                <ul className="nav nav-category" data-aos="fade-in">
                                    <li>
                                        <NavLink to={(prop.lang === 'en' ? '/en':'') + '/scholarship'} className={"btn" + (typeof slug === 'undefined' ? ' active':'')}>{prop.lang === 'en' ? 'View all':'ทั้งหมด'}</NavLink>
                                    </li>
                                    {
                                        category !== null && category.count > 0 ?
                                            category.rows.map((row, index) => {
                                                return (
                                                    <li key={index}>
                                                        <NavLink to={(prop.lang === 'en' ? '/en':'') + '/scholarship/category/' + row.slug} className={"btn" + (slug === row.slug ? ' active':'')}>
                                                         {prop.lang === 'en' ? row.title_en:row.title}
                                                        </NavLink>
                                                    </li>
                                                )
                                            }) : ''
                                    }
                                </ul>

                                {
                                    listing !== null && listing.count > 0 ?
                                        <>
                                            <div className="row card-news-lists">
                                                {
                                                    listing.rows.map((row, index) => {
                                                        return (
                                                            <div key={index} className="col-md-4 col-sm-6">
                                                                <div className="card-news bg-none" data-aos="fade-in">
                                                                    <NavLink to={(prop.lang === 'en' ? '/en':'') + '/scholarship/detail/' + row.slug} className="card-link"></NavLink>
                                                                    <div className="card-photo">
                                                                        <div className="photo"
                                                                             style={{backgroundImage: 'url("' + (row?.image !== null ? Config.fileUpload + 'scholarship/' + row?.image : defaultImage) + '")'}}>
                                                                            <img src={frameDefault} alt="" />
                                                                        </div>
                                                                        <label className="date">{Utils.dateDM(row.createdAt, prop.lang)}</label>
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>

                                            <div className={totalPage > 1 ? '':'d-none'}>
                                                <Pagination
                                                    itemClassPrev="arrow prev"
                                                    itemClassNext="arrow next"
                                                    activeClass="active"
                                                    itemClass=""
                                                    linkClass=""
                                                    innerClass="pagination"
                                                    activePage={activePage}
                                                    itemsCountPerPage={itemPerpage}
                                                    totalItemsCount={countAllItem}
                                                    pageRangeDisplayed={5}
                                                    onChange={(pageNum) => onPageChange(pageNum)}
                                                />
                                            </div>

                                        </> : <p>{prop.lang === 'en' ? 'Not found':'ไม่พบข้อมูล'}</p>

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 